import {FC} from "react";

const Table: FC = ({children}) => {
    return (
        <div className="flex flex-col">
            <div className="overflow-x-auto">
                <div className="inline-block min-w-full">
                    <div className="overflow-hidden shadow-md sm:rounded-lg">
                        <table className="min-w-full">
                            {children}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TH: FC<{onClick?: () => void}> = ({children, onClick}) => (
    <th scope="col"
        onClick={onClick}
        className="py-3 px-6 text-xs font-medium tracking-wider text-left dark:text-accentGray text-white uppercase">
        {children}
    </th>
);
const TD: FC<{colspan?: number; className?: string}> = ({children,colspan, className}) => <td colSpan={colspan} className={`py-4 px-6 text-sm whitespace-nowrap dark:text-white ${className}`}>{children}</td>;
const HeadTR: FC = ({children}) => <tr>{children}</tr>;

const BodyTR: FC = ({children}) => <tr className="bg-primary/20 text-black dark:text-white dark:bg-mainGray/50">{children}</tr>;

const THead: FC = ({children}) => <thead className="bg-primary dark:bg-mainGray">{children}</thead>;
const TBody: FC = ({children}) => <tbody className='divide-y divide-white/5'>{children}</tbody>;

const components = {
    Skeleton: Table,
    TH,
    TD,
    HeadTR,
    BodyTR,
    THead,
    TBody
}

export default components;